import useSuggestionsOnChange from './useSuggestionsOnChange'

export default useSuggestionsOnChange
